import React, { useEffect } from 'react';
import formatFileCategory from '../../../commom/formatFileCategory';
import { Button } from '../../atoms/Button';
import { Pdf } from '../../atoms/Pdf';
import PageHeader from '../../molecules/Header';
import { Typography } from '../../molecules/Typography';
import { Breadcrumbs, BreadcrumbsItem } from '../Breadcrumbs';
import { ContentActions } from '../ContentActions';
import { IFavoriteCategory } from '../ContentActions/FavoriteButton';

interface IMaterial {
  title: string;
  discipline?: string;
  file: string;
  materialType: string;
  materialId: string;
  materialSlug: string;
  review: 'like' | 'dislike' | undefined;
  isFavorite?: boolean;
  showFavorite?: boolean;
  breadcrumb?: Array<BreadcrumbsItem>;
  markMaterialView?: () => void;
}

const Material = React.memo(function Material({
  title,
  materialSlug,
  discipline,
  file,
  materialType,
  materialId,
  breadcrumb = [],
  isFavorite,
  review,
  showFavorite = true,
  markMaterialView,
}: IMaterial) {
  useEffect(() => {
    if (materialId && markMaterialView) {
      markMaterialView();
    }
  }, [materialId]);


  file = file.replace("{STORAGE_BASE_URL}", "https://storage.aprovatotal.com.br")

  return (
    <div>
      <Breadcrumbs items={breadcrumb} className='pb-12' />

      <div className='pb-8'>
        <PageHeader title={title} module={discipline}>
          <div className='flex flex-col justify-between gap-md md:flex-row'>
            <div className='flex items-center gap-3'>
              <Typography size='small' className='capitalize'>
                {formatFileCategory(materialType)}
              </Typography>
            </div>

            <ContentActions.Root
              contentType={'Material'}
              contentId={materialId}
              contentSlug={materialSlug}
              className={'ml-auto'}
            >
              <ContentActions.ReviewButtons defaultReview={review} />
              {showFavorite && (
                <ContentActions.FavoriteButton
                  defaultFavorite={isFavorite}
                  category={materialType as IFavoriteCategory}
                />
              )}
              <ContentActions.Report />
            </ContentActions.Root>
          </div>
        </PageHeader>
      </div>

      <div>
        <Pdf file={file} />
      </div>

      {file && (
        <div className='flex justify-end pt-8'>
          <a href={file} target='_blank' rel='noreferrer'>
            <Button LeftIcon='open_in_new' variant='text'>
              Abrir em nova guia
            </Button>
          </a>
        </div>
      )}
    </div>
  );
});

export default Material;
